import { ChangeDetectionStrategy, Component } from '@angular/core';
import { marker } from '@common/translate-marker';
import { TranslateService } from '@ngx-translate/core';
import { DialogRef } from '@progress/kendo-angular-dialog';
import { environment } from 'environments/environment';
import * as _ from 'lodash';

@Component({
    template: `
        <div class="modal-header">
            <div class="row" style="width: 100%">
                <div class="col-10">
                    <h4 class="modal-title">{{ title }}</h4>
                </div>
                <div class="col-2">
                    <button class="close" type="button" aria-label="Close" (click)="activeModal.close()">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
            </div>
        </div>
        <div class="modal-body">
            <div class="alert alert-danger" role="alert">
                <div [innerHTML]="message"></div>
            </div>

            @if (hasStackTrace()) {
                <div>
                    <div class="panel panel-danger">
                        <div class="panel-heading" translate>StackTrace</div>
                        <div class="panel-body">
                            <pre
                                style="color: #c7254e; max-height: 500px; overflow-y: scroll;"
                                [innerHTML]="stackTrace"></pre>
                        </div>
                    </div>
                </div>
            }
        </div>
        <div class="modal-footer">
            <button class="btn btn-sm btn-primary" translate (click)="activeModal.close(true)">Ok</button>
        </div>
    `,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ErrorDialogComponent {
    stackTrace: string;
    message: string;
    titleText: string;
    validationErrors: any[];

    constructor(
        public activeModal: DialogRef,
        private translateService: TranslateService
    ) {}

    get title() {
        if (this.titleText) {
            return this.titleText;
        }

        return this.validationErrors
            ? this.translateService.instant(marker('Validation failed'))
            : this.translateService.instant(marker('An error has occurred'));
    }

    hasStackTrace() {
        return !!this.stackTrace;
    }

    setMessage(message, exception, errors) {
        this.message = '';
        if (this.validationErrors?.length > 0) {
            const errors = this.validationErrors.map((e) => `<li>${e.errorMessage}</li>`).join('');
            this.message = `<ul>${errors}</ul>`;
            return;
        }

        if (message) {
            this.message = `<h6>${message}</h6><br />`;
        }

        if (typeof exception === 'string' && exception.length > 0) {
            const index = exception.indexOf('at Bulgaria.');

            const safeException = index > -1 ? exception.substring(0, index) : exception;

            this.message += `<span>${safeException}</span><br />`;
        }

        // append errors array if provided
        if (Array.isArray(errors) && errors.length > 0) {
            errors.forEach((err) => {
                this.message += `<span>${err}</span><br />`;
            });
        }
    }

    setStackTrace(stackTrace) {
        if (environment.production) return;

        if (stackTrace && !_.isString(stackTrace)) {
            console.error(stackTrace);
            stackTrace = stackTrace.toString();
        }

        this.stackTrace = stackTrace;
    }
}
